<script lang="ts">
	import Spinner from '$lib/components/Spinner.svelte';

	import ContentItem from '$lib/components/ContentItem.svelte';
	import { t } from '$lib/i18n';
	import { goto } from '$app/navigation';
	export let data: {
		foundContent: { count: number; results: any[] };
		searchParam: any;
		brand: any;
	};

	let loadingMore = false;

	let skip = 0;
	const loadMore = async () => {
		loadingMore = true;
		let newSkip = skip + 9;
		const res = await fetch(
			'/api/content?take=9' + `&skip=${newSkip}&brand=${data?.searchParam ?? ''}`,
			{ method: 'GET' }
		);
		if (!res.ok) {
			return;
		}
		const newContent = await res.json();
		if (newContent?.length > 0) {
			skip = newSkip;
		}
		data.foundContent = {
			count: data.foundContent.count + newContent.length,
			results: [...data.foundContent.results, ...(newContent?.results ?? [])]
		};
		loadingMore = false;
	};
</script>

<div class="bg-white hero">
	<div class="md:flex p-2 justify-between max-w-[85rem] mx-auto pb-[1rem] my-[3rem] px-10">
		<div class="mb-[4rem]">
			<img
				src={data?.brand?.logoUrl}
				class="max-h-[3rem] mt-2 inline-block"
				alt="{data?.brand?.name ?? ''} logo"
			/>
			<div class="mt-16 text-xl text-black">
				{@html data.brand?.synopsis
					.replace(/style="[^"]*"/g, '')
					.replace(/<p>/g, '<p style="margin-top: 1rem; margin-bottom: 1rem;">')}			</div>
		</div>

		<div class="text-center">
			<a
				target="_blank"
				class="block bg-light-green px-[3rem] py-[1rem] rounded-[0.5rem] text-white"
				href={data?.brand?.contactUsUrl}
			>
				{$t('page.vendors.contact', { default: 'Contact Vendor' })}
			</a>
		</div>
	</div>
</div>

<div class="search-results bg-dark-green bg-opacity-10">
	<div class="max-w-[120rem] p-[2rem] mx-auto text-center">
		<div class="articles md:flex flex-row flex-wrap justify-center gap-[2rem]">
			{#if data?.foundContent?.results?.length > 0}
				<div
					class="grid max-w-2xl grid-cols-1 mx-auto mt-16 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3"
				>
					{#each data.foundContent.results as content}
						<ContentItem {content} />
					{/each}
				</div>
			{:else}
				<div class="w-full h-32 text-2xl text-center">
					{$t('common.sorry-no-content', {
						default: 'Sorry, no content could be found at this time.'
					})}
				</div>
			{/if}
		</div>

		<div class="flex items-center justify-center w-full py-10">
			<button
				class:hidden={data?.foundContent?.results?.length === 0}
				on:click={loadMore}
				class="bg-light-green px-[2rem] py-[1rem] rounded-xl text-xl text-white"
				><span class="mr-2" class:hidden={!loadingMore}><Spinner /></span>{$t('common.load-more', {
					default: `Load More`
				})}</button
			>
		</div>
	</div>
</div>
